// DS: CO0.1M
import React from 'react';
import classnames from 'classnames';
import PublishedTime from '../_partials/PublishedTime';
import WatchButton from './WatchButton';
import MoneyPromoButton from './MoneyPromoButton';
import BackButton from './BackButton';
import RootLayout from './RootLayout';
import UserInfoBlock from './UserInfoBlock';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { ThemeOptions, ThemeOverride } from '@wix/da-react-context/pkg/ThemeContext';
import s from './MobileSubmissionDetailsHeader.scss';
const MobileSubmissionDetailsHeader = ({ currentItem, isOwner, parent, isSticky = true, isStuck })=>{
    var _currentItem, _currentItem_extended, _currentItem1, _currentItem2, _currentItem3;
    const publishedTime = (_currentItem = currentItem) === null || _currentItem === void 0 ? void 0 : _currentItem.publishedTime;
    let moneyPromo = (_currentItem1 = currentItem) === null || _currentItem1 === void 0 ? void 0 : (_currentItem_extended = _currentItem1.extended) === null || _currentItem_extended === void 0 ? void 0 : _currentItem_extended.showStageMonetizationPromo;
    const author = (_currentItem2 = currentItem) === null || _currentItem2 === void 0 ? void 0 : _currentItem2.author;
    const redesigned_money_banners = useFlag('redesigned_money_banners');
    // If this is an adoptable that's on sale or has sold, we need to remove
    // the monetization promo components. We'll do that by setting `moneyPromo` to undefined
    if (((_currentItem3 = currentItem) === null || _currentItem3 === void 0 ? void 0 : _currentItem3.isAdoptable) && (!currentItem.adoptable || [
        'onsale',
        'sold',
        'pending'
    ].includes(currentItem.adoptable.status))) {
        moneyPromo = undefined;
    }
    const content = /*#__PURE__*/ React.createElement(RootLayout, {
        className: classnames(s['root'], isSticky && s['sticky'], isStuck && s['stuck'], moneyPromo && s['money-promo'], redesigned_money_banners && s['redesigned-money-banners']),
        prefix: parent && /*#__PURE__*/ React.createElement(BackButton, null),
        left: /*#__PURE__*/ React.createElement(React.Fragment, null, author && /*#__PURE__*/ React.createElement(UserInfoBlock, {
            user: author,
            publishedTime: publishedTime
        }), !author && publishedTime && /*#__PURE__*/ React.createElement(PublishedTime, {
            publishedTime: publishedTime,
            withoutText: true
        })),
        right: /*#__PURE__*/ React.createElement(React.Fragment, null, moneyPromo && author && /*#__PURE__*/ React.createElement(MoneyPromoButton, {
            moneyPromo: moneyPromo,
            user: author,
            relevantDeviation: currentItem
        }), !moneyPromo && !isOwner && author && /*#__PURE__*/ React.createElement(WatchButton, {
            user: author
        }))
    });
    return redesigned_money_banners ? /*#__PURE__*/ React.createElement(ThemeOverride, {
        theme: ThemeOptions.DARK
    }, content) : content;
};
MobileSubmissionDetailsHeader.displayName = 'MobileSubmissionDetailsHeader';
export default MobileSubmissionDetailsHeader;
